<template>
	<v-dialog :value="this.showDialog" persistent max-width="600">
		<v-card class="confirm-dialog">
			<div class="title">{{ isEdit ? "Edit" : "Create New" }} Scheme</div>
			<v-divider style="margin-top: 12px;" />
			<div class="pa-2">
				<v-flex mb-4>
					<span class="body-2">Scheme Image</span>
					<upload-media
						accept="image/*"
						@SAVE_FILE_URL="saveSchemeImage"
						:fileUrl="schemeImgUrl"
					/>
				</v-flex>
				<v-flex>
					<v-btn
						flat
						small
						round
						:color="themeInputColor"
						@click="selectedUserTypes = Object.keys(storeTypes)"
					>
						Select all user types
					</v-btn>
					<v-autocomplete
						label="Select User Types"
						v-model="selectedUserTypes"
						:items="Object.keys(storeTypes)"
						autocomplete
						placeholder="Select User Type"
						:color="themeInputColor"
						clearable
						box
						multiple
						small-chips
						deletable-chips
						:loading="isSubmittingForm"
					/>
					<v-btn
						flat
						small
						round
						:color="themeInputColor"
						@click="selectedStates = states"
					>
						Select all states
					</v-btn>
					<v-autocomplete
						label="Select States"
						v-model="selectedStates"
						:items="states"
						autocomplete
						placeholder="Select States"
						:color="themeInputColor"
						clearable
						box
						multiple
						small-chips
						deletable-chips
						:loading="isSubmittingForm"
					/>
					<v-autocomplete
						label="Select App Type"
						v-model="selectedAppType"
						:items="['rummy', 'fantasy']"
						autocomplete
						placeholder="Select App Type"
						:color="themeInputColor"
						clearable
						box
						:loading="isSubmittingForm"
					/>
					<v-text-field
						label="Enter Ranking"
						v-model="ranking"
						placeholder="Enter Ranking"
						:color="themeInputColor"
						clearable
						box
						:loading="isSubmittingForm"
					/>
				</v-flex>
				<v-flex>
					<div class="d-flex align-center full-width">
						<v-layout
							class="full-width"
							@click="startDate.modal = true"
						>
							<v-dialog
								ref="dialog"
								v-model="startDate.modal"
								:return-value.sync="startDate.date"
								persistent
								width="270px"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-flex class="px-1">
										<v-text-field
											v-model="startDate.display"
											label="Select Start Date"
											v-bind="attrs"
											v-on="on"
											placeholder="Select Start Date"
											box
											:color="themeInputColor"
											:loading="isSubmittingForm"
										></v-text-field>
									</v-flex>
								</template>
								<v-date-picker
									v-model="startDate.date"
									:show-current="false"
									no-title
									elevation="15"
									:color="themeInputColor"
									class="btn"
									width="270px"
								>
									<v-spacer></v-spacer>
									<v-btn
										flat
										small
										round
										:color="themeInputColor"
										@click="startDate.modal = false"
									>
										Cancel
									</v-btn>
									<v-btn
										flat
										small
										round
										:color="themeInputColor"
										:disabled="!startDate.date"
										@click="() => setDate(true)"
									>
										OK
									</v-btn>
								</v-date-picker>
							</v-dialog>
						</v-layout>
						<div>TO</div>
						<v-layout
							class="full-width"
							@click="endDate.modal = !!startDate.date"
						>
							<v-dialog
								ref="endDateDialog"
								v-model="endDate.modal"
								:return-value.sync="endDate.date"
								persistent
								width="270px"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-flex class="px-1">
										<v-text-field
											v-model="endDate.display"
											label="Select End Date"
											v-bind="attrs"
											v-on="on"
											placeholder="Select End Date"
											box
											:color="themeInputColor"
											:disabled="!startDate.date"
											:loading="isSubmittingForm"
										></v-text-field>
									</v-flex>
								</template>
								<v-date-picker
									v-model="endDate.date"
									:show-current="false"
									no-title
									elevation="15"
									:color="themeInputColor"
									class="btn"
									:min="startDate.date"
									:disabled="!startDate.date"
									width="270px"
								>
									<v-spacer></v-spacer>
									<v-btn
										flat
										small
										round
										:color="themeInputColor"
										@click="endDate.modal = false"
									>
										Cancel
									</v-btn>
									<v-btn
										flat
										small
										round
										:color="themeInputColor"
										:disabled="!endDate.date"
										@click="() => setDate(false)"
									>
										OK
									</v-btn>
								</v-date-picker>
							</v-dialog>
						</v-layout>
					</div>
				</v-flex>
			</div>
			<v-divider style="margin-bottom: 8px;" />
			<v-card-actions>
				<v-btn
					flat
					round
					:color="themeInputColor"
					@click="() => this.$emit('closeDialog')"
					:disabled="isSubmittingForm"
					>Cancel</v-btn
				>
				<v-btn
					round
					:dark="!isSubmitBtnDisabled"
					:color="themeInputColor"
					:disabled="isSubmitBtnDisabled"
					:loading="isSubmittingForm"
					@click="submitForm"
					>{{ isEdit ? "Edit" : "Create" }}</v-btn
				>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import UploadMedia from "@/components/UploadMedia";
import { MONTHS } from "../../constants";
import {
	CREATE_RETAIL_SCHEME,
	UPDATE_RETAIL_SCHEME
} from "../../../store/action-types";
export default {
	props: [
		"showDialog",
		"themeInputColor",
		"isEdit",
		"storeTypes",
		"states",
		"selectedScheme"
	],
	components: {
		"upload-media": UploadMedia
	},
	data() {
		return {
			schemeImgUrl: "",
			selectedUserTypes: [],
			selectedStates: [],
			selectedAppType: "",
			ranking: "",
			startDate: {
				date: "",
				modal: false,
				display: ""
			},
			endDate: {
				date: "",
				modal: false,
				display: ""
			},
			isSubmittingForm: false
		};
	},
	computed: {
		isSubmitBtnDisabled() {
			return (
				!this.schemeImgUrl ||
				!this.selectedUserTypes.length ||
				!this.selectedStates.length ||
				!this.selectedAppType ||
				!this.ranking ||
				!this.startDate.date ||
				!this.endDate.date
			);
		}
	},
	methods: {
		saveSchemeImage(url) {
			if (url) {
				this.schemeImgUrl = url.fileUrl;
			}
		},
		getDateToDisplay(date) {
			const [stYear, stMonth, stDate] = date.split("-");
			return `${stDate} ${MONTHS[Number(stMonth) - 1].substr(
				0,
				3
			)} ${stYear.substr(2)}`;
		},
		setDate(isStartDate) {
			if (isStartDate) {
				this.$refs.dialog.save(this.startDate.date);
				this.startDate.display = this.getDateToDisplay(
					this.startDate.date
				);
			} else {
				this.$refs.endDateDialog.save(this.endDate.date);
				this.endDate.display = this.getDateToDisplay(this.endDate.date);
			}
		},
		submitForm() {
			if (this.isSubmittingForm) return;
			this.isSubmittingForm = true;
			const userTypes = [...this.selectedUserTypes].map(
				userType => this.storeTypes[userType]
			);
			const payload = {
				...(this.isEdit ? { id: this.selectedScheme.id } : {}),
				imageURL: this.schemeImgUrl,
				userTypes,
				states: this.selectedStates,
				appType: this.selectedAppType,
				ranking: +this.ranking,
				startTime: new Date(this.startDate.date).getTime(),
				endTime: new Date(this.endDate.date).getTime()
			};
			this.$store
				.dispatch(
					this.isEdit
						? UPDATE_RETAIL_SCHEME.dispatch
						: CREATE_RETAIL_SCHEME.dispatch,
					payload
				)
				.then(() => {
					this.$emit("closeDialog");
				})
				.finally(() => {
					this.isSubmittingForm = false;
				});
		}
	},
	watch: {
		selectedScheme(newVal = {}) {
			const {
				imageURL = "",
				ranking = "",
				appType = "",
				startTime = "",
				endTime = "",
				userTypes = [],
				states = []
			} = newVal;
			this.schemeImgUrl = imageURL;
			this.selectedUserTypes = [...userTypes].map(userType =>
				Object.keys(this.storeTypes).find(
					key => this.storeTypes[key] === userType
				)
			);
			this.selectedStates = states;
			this.selectedAppType = appType;
			this.ranking = ranking;
			this.startDate.date = this.isEdit
				? new Date(startTime).toISOString().split("T")[0]
				: "";
			this.endDate.date = this.isEdit
				? new Date(endTime).toISOString().split("T")[0]
				: "";
			this.startDate.display = this.isEdit
				? this.getDateToDisplay(this.startDate.date)
				: "";
			this.endDate.display = this.isEdit
				? this.getDateToDisplay(this.endDate.date)
				: "";
		}
	}
};
</script>
<style scoped>
.confirm-dialog {
	display: flex;
	flex-direction: column;
	padding: 12px;
	background-color: #fafafa;
	border-radius: 8px;
}
</style>
